import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import styles from './index.scss';
import classnames from 'classnames';
import { isNullOrEmpty } from '../../../../common/utils';

import { capitalize } from '../../../../../util/lodashlike';
const { Option, OptGroup } = Select;

const RunInstanceName = ({
  saveRunInstanceConfigToStore,
  values,
  handleChange,
  handleOnBlur,
  modulesList
}) => {
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({
    name: '',
    description: '',
    sourceId: ''
  });

  const onChangeHandler = (e) => {
    const { name, value, min, max } = e.target;
    handleChange(name, value);

    if (!!value && !/^[\p{L}\p{N}\p{M}]/u.test(value)) {
      setErrors({
        ...errors,
        [name]: capitalize(
          `${name} cannot start with space or special characters.`
        )
      });
    } else if (!!value && !/^[\p{L}\p{N}\p{M}\s\-_]*$/u.test(value)) {
      setErrors({
        ...errors,
        [name]: 'Supported special characters are _ - and space.'
      });
    } else if (value?.length < min || value?.length > max) {
      setErrors({
        ...errors,
        [name]: capitalize(`${name} must be ${min}-${max} characters.`)
      });
    } else {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const onBlur = (e) => {
    const { name, value, required } = e.target;
    if (value === '' && required) {
      // for Required validation
      setErrors({
        ...errors,
        [name]: `Please input run instance ${name}.`
      });
      handleOnBlur();
    }
  };

  useEffect(() => {
    let isValidationPassed = false;

    if (
      !isNullOrEmpty(values?.name) &&
      !isNullOrEmpty(values?.description) &&
      !isNullOrEmpty(values?.sourceId) &&
      !Object.values(errors).some((err) => !isNullOrEmpty(err))
    ) {
      isValidationPassed = true;
    }

    if (saveRunInstanceConfigToStore)
      saveRunInstanceConfigToStore(
        'runInstanceConfig',
        values,
        isValidationPassed
      );
  }, [values, errors]);

  const moduleSelectHandler = (val) => {
    handleChange('sourceId', val);
    let newData = {
      ...values,
      sourceId: val
    };
    setErrors({
      ...errors,
      sourceId: ''
    });
  };

  const onBlurSelectHanlder = () => {
    if (values?.sourceId !== '')
      setErrors({
        ...errors,
        sourceId: ''
      });
    else
      setErrors({
        ...errors,
        sourceId: 'Please select run instance module.'
      });
  };

  return (
    <Form className={styles.form} initialValues={values} form={form}>
      <div style={{ maxWidth: '256px', paddingTop: '24px' }}>
        <label
          required="required"
          className={classnames(styles.label, styles.required)}>
          Run Instance Name
        </label>
        <Input
          name="name"
          id={'runInstanceName-input'}
          title=""
          className={styles.input}
          value={values?.name}
          onChange={onChangeHandler}
          placeholder="Run Instance Name"
          onBlur={onBlur}
          required={true}
          min={3}
          max={100}
        />
        {errors.name !== '' && (
          <p className={styles.errorMessage} id="error_name">
            {errors.name}
          </p>
        )}
      </div>
      <div style={{ maxWidth: '556px' }}>
        <label className={classnames(styles.label, styles.required)}>
          Run Instance Description
        </label>
        <Input
          name="description"
          id={'runInstanceName-description'}
          title=""
          className={styles.input}
          value={values?.description}
          onChange={onChangeHandler}
          placeholder="Run Instance Description"
          onBlur={onBlur}
          required={true}
          min={3}
          max={200}
        />
        {errors.description !== '' && (
          <p className={styles.errorMessage} id="error_description">
            {errors.description}
          </p>
        )}
      </div>
      <div
        style={{ maxWidth: '256px', display: 'flex', flexDirection: 'column' }}>
        <label className={classnames(styles.label, styles.required)}>
          Run Instance Module
        </label>
        <Select
          placeholder="Select Module"
          value={values?.sourceId ? values?.sourceId : null}
          id="moduleType"
          dropdownClassName="moduleType"
          onChange={moduleSelectHandler}
          onBlur={onBlurSelectHanlder}>
          <OptGroup label="Select Module">
            {modulesList?.map((item, index) => (
              <Option value={item.value} key={index}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        </Select>
        {errors.sourceId !== '' && (
          <p className={styles.errorMessage} id="error_module">
            {errors.sourceId}
          </p>
        )}
      </div>
    </Form>
  );
};

export default RunInstanceName;
